import React from "react";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./ProductSkeleton";
import EmptyProductsState from "./EmptyProductsState";
import "../../styles/sectionPage.css";

/**
 * Controller-like component that handles rendering products grid, toolbar, skeleton, or empty state.
 * @param {Object} props
 * @param {Array} props.products - Array of filtered products
 * @param {boolean} props.loading - Loading state
 * @param {string} props.sectionColor - Accent color for styling
 */
const SectionProducts = ({ products = [], loading = false, sectionColor }) => {
  const accentStyle = {
    "--section-color": sectionColor || "#ff6a00",
  };

  return (
    <div className="section-products-container" style={accentStyle}>
      {/* 1. Products Toolbar (All Products Label + Sort dropdown placeholder) */}
      <div className="products-toolbar">
        <span className="products-toolbar-title">All Products</span>
        <div className="products-toolbar-sort">
          <span className="sort-label">Sort:</span>
          <div className="sort-select-wrapper">
            <select className="sort-select" defaultValue="newest" disabled>
              <option value="newest">Newest First</option>
            </select>
            <span className="sort-select-arrow">&#9662;</span>
          </div>
        </div>
      </div>

      {/* 2. Listing body: Loader skeleton, empty cards, or list cards */}
      {loading ? (
        <ProductSkeleton />
      ) : products.length === 0 ? (
        <EmptyProductsState sectionColor={sectionColor} />
      ) : (
        <div className="products-grid">
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              sectionColor={sectionColor}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionProducts;
